document.addEventListener('DOMContentLoaded', function() {
  let formChanged = false;
  let emailBrandingForm = document.getElementById("email-branding-style-sheet-form");
  let EMAIL_BRANDING_FILE_LIMITS = $('#email_branding_file_limits').val() && JSON.parse($('#email_branding_file_limits').val());
  let fileObject = {};

  if (emailBrandingForm){
     setupUnsavedChangesAlert(emailBrandingForm)         
     setColorFontEventListeners();          
     toggleCropBtnVisibility();
    emailBrandingForm.addEventListener('submit', function(e) {
        e.preventDefault();         
        setImageUploadCropDeleteListener();
     })
  }  

  function setImageUploadCropDeleteListener(){
    emailBrandingForm.querySelectorAll('.content-image-container').forEach(function(imageUploaded) {
      let imgSrc = imageUploaded.querySelector('img').getAttribute('src');
      if (imgSrc !== undefined && imgSrc !== null && imgSrc.indexOf("base64") !== -1) {
        imageUploaded.querySelector('.content-for-image').value = (imgSrc.replace(/^data:image\/(png|jpg|jpeg|gif);base64,/, ""))
      } else if (imgSrc === undefined || imgSrc === null) {
        imageUploaded.querySelector('.content-for-image').value = 'null';
      }
    });
    formChanged = false;          
    emailBrandingForm.submit();    
  }

  function setupUnsavedChangesAlert(form) {
     form.addEventListener('change', function () {
       formChanged = true;
     });
     
     form.addEventListener('input', function () {
        formChanged = true;
      });         

     
     let dropDowns = form.querySelectorAll(".trigger-form-changed");
     if(dropDowns){
       dropDowns.forEach((dropDown) => {
         dropDown.onchange = function () {
           formChanged = true;
         }
       });
     }
     
     const sendTestEmailBtn = document.querySelector('.send-test-email-btn');
     sendTestEmailBtn.addEventListener('click', function(event){                    
        if(formChanged){
          const confirmation = confirm('Your changes have not been saved yet. Are you sure you would like to save these changes? Email would be sent with the current changes');
           if (!confirmation) {
             event.preventDefault(); 
            }
            else{                  
              event.preventDefault();                   
              const send_test_email_field = document.querySelector('#send_test_email_field')
              send_test_email_field.value = 'true';
              setImageUploadCropDeleteListener();            
           }
        }
    });     

     const sideMenuButtons = document.querySelectorAll('.side-menu-items-editor');
     if(sideMenuButtons){
       sideMenuButtons.forEach(button => {
         button.addEventListener('click', function(event){
           if(formChanged){
             const confirmation = confirm('Are you sure you would like to continue without saving? Email branding styling will not be applied to the emails.');
             if (!confirmation) {
               event.preventDefault();
             }
             else{
               formChanged = false;
             }
           }
         });
       });
     }

     window.addEventListener('beforeunload', function (e) {
       if (formChanged) {
         let confirmationMessage = 'You have unsaved changes. Are you sure you want to leave?';
         (e || window.event).returnValue = confirmationMessage;
         return confirmationMessage;
       }
     });
   }

   function toggleCropBtnVisibility(){
      const cropBtn = document.querySelector('.email-branding-crop-btn');
      const is_present = cropBtn.classList.contains('display-none')
      if (is_present) {
        cropBtn.style.visibility = 'hidden';
      } else {
        cropBtn.style.visibility = 'visible';          
      }        
   }
  
  function setColorFontEventListeners(){
    const emailTitlefontContainer = document.querySelector('.email-title-font-selector');
    const emailTitleColorContainer = document.querySelector('.email-title-color-selector');
    const emailBodyFontContainer = document.querySelector('.email-body-font-selector');
    const emailBodyColorContainer = document.querySelector('.email-body-color-selector');
    const emailTitlePreviewBox = document.querySelector('.email-title-preview-box');
    const emailBodyPreviewBox = document.querySelector('.email-body-preview-box');
    const emailHeaderColorSelector = document.querySelector('.email-header-color-selector');    
    const emailButtonColorSelector = document.querySelector('.email-button-color-selector');    

   if (emailTitlefontContainer) {
    emailTitlefontContainer.onchange = function() {
       const selectedFont = emailTitlefontContainer.options[emailTitlefontContainer.selectedIndex].value;
       emailTitlePreviewBox.style.fontFamily = selectedFont;
       formChanged = true;            
     };
   }
   if (emailBodyFontContainer) {
    emailBodyFontContainer.onchange = function() {
       const selectedFont = emailBodyFontContainer.options[emailBodyFontContainer.selectedIndex].value;
       emailBodyPreviewBox.style.fontFamily = selectedFont;
       formChanged = true;            
     };
   }  
   if (emailTitleColorContainer) {
    emailTitleColorContainer.onchange = function() {
       const selectedColor = emailTitleColorContainer.value;
       emailTitlePreviewBox.style.color = selectedColor;
       formChanged = true;            
     };
   }         
   if (emailBodyColorContainer) {
    emailBodyColorContainer.onchange = function() {
       const selectedColor = emailBodyColorContainer.value;
       emailBodyPreviewBox.style.color = selectedColor;
       formChanged = true;            
     };
   }
   if (emailHeaderColorSelector) {
    emailHeaderColorSelector.onchange = function() {
       formChanged = true;            
     };
   }   
   if (emailButtonColorSelector) {
    emailButtonColorSelector.onchange = function() {
       formChanged = true;            
     };
   }      
 }        

  function handleFileChange(event, fileType) {
     const container      = $(this).parents('.content-image-container');
     const filePreview    = container.find(".upload-email-branding-logo-image img");
     const altTextModal   = container.find(".edit-alt-text-image-modal");
     const fileTypeInput  = container.find(".type-for-image");
     const fileNameInput  = container.find(".name-for-image");
     const removeImageBtn = container.find('.remove-email-branding-image');
     const cropBtn        = container.find(".edit-email-branding-image-modal");
  
     let input = $(event.currentTarget);
     let file = input[0].files[0];
  
     if (!file) return;
  
     if (fileSizeNotInLimit(file, event, fileType, EMAIL_BRANDING_FILE_LIMITS[fileType])) return;
  
     fileTypeInput.val(file.type);
     fileNameInput.val(file.name);
     altTextModal.removeClass("display-none");
     cropBtn.removeClass("display-none");
  
     removeImageBtn.css({
         "opacity": 1,
         "pointer-events": "all"
     });
  
     const reader = new FileReader();
     reader.onload = function (e) {
         filePreview.attr("src", e.target.result);
     };
  
     reader.readAsDataURL(file);
     this.value = "";
   }
  

   $(".upload-email-branding-logo-file").change(function (event) {
        handleFileChange.call(this, event, "image");
        toggleCropBtnVisibility()          
    });       
  
   $(".remove-email-branding-image").click(function (event) {    
     formChanged = true         
     $($(event.target)[0]).parents('.content-image-container').find('.upload-preview-email-branding-image').find("img").attr("src", null);
     $($(event.target)[0]).parents('.content-image-container').find('.edit-email-branding-image-modal').addClass("display-none"); 
     $(this).css("opacity", 0.5);
     $(this).css("pointer-events", "none");
     toggleCropBtnVisibility()
   })
  
    $(".edit-email-branding-image-modal").click(function (event) {    
     formChanged = true
     $("#image_modal").openModal();
     $("#image_modal").html('<div class="center-align"><i class="fa fa-spinner fa-spin fa-3x"></i></div>');
     let cropbox = '#email_branding_edit_image_cropbox';
     $(cropbox).attr("src", $("#uploaded-image")[0].src);
     let details = $(this).data('file-details').split(',');
     if (!fileObject.filetype_image && details.length > 1) {
       $(this).parents('.content-image-container').find('.name-for-image').val(details[0]);
       $(this).parents('.content-image-container').find('.type-for-image').val(details[1].slice(1));
     }
   });            
  }) 